<template>
  <section 
    class="ContentSection"
    :class="SectionClassList">
    <slot/>
  </section>
</template>

<script>
export default {
  name: 'ContentSection',
  props: {
    wide: {
      type: Boolean,
      default: false
    },
    grow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    SectionClassList() {
      return {
        'ContentSection--wide' : this.wide,
        'ContentSection--grow' : this.grow
      }
    }
  }
}
</script>

<style lang="scss">
  .ContentSection {
    position: relative;
    padding: 32px 16px 16px 32px;

    p, ul, ol {
      font-family: $font_body;
      font-size: 16px;
      margin: 0;
      padding: 0;
      line-height: 30px;
      letter-spacing: -0.02px
    }

    p + p {
      margin-top: 16px;
    }

    ul {
      margin-left: 24px;

      li {
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .Link {
      display: inline-block;
      font-size: 16px;
      margin-top: 16px;
    }

    &--wide {
      .SectionHeader {
        font-size: 24px;
        margin-left: 32px;
        margin-right: 80px;
      }

      .ContentVideo {
        margin-left: 32px;
        margin-right: 80px;
      }

      h3:not(.SectionHeader) {
        margin: 24px 80px 24px 32px;
        font-size: 32px;
        font-family: $font_header
      }

      p, ul, ol {
        font-family: $font_body;
        font-size: 20px;
        letter-spacing: -0.01px;
        margin: 24px 80px 24px 32px;
        line-height: 36px;
      }
      ul, ol {
        margin: 12px 16px 12px 64px;

        ul, ol {
          margin: 0 0 0 32px
        }
      }
    }
    
    &--grow {
      flex-grow: 1
    }
  }
</style>
